import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './VerifyIdentityPage.css';

function VerifyIdentityPage() {
  const [verifyMethod, setVerifyMethod] = useState('email');

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(`Verification code will be sent via ${verifyMethod}! (This is a demo)`);
  };

  return (
    <div className="verify-page">
      {/* Main Container */}
      <div className="verify-container">
        {/* Left Panel - Illustration */}
        <div className="verify-promo-panel">
          <img 
            src="/verify-illustration.png" 
            alt="Ontraport Illustration"
            className="promo-image"
          />
        </div>

        {/* Right Panel - Verify Form */}
        <div className="verify-form-panel">
          {/* Logo */}
          <Link to="/" className="verify-logo">
            ontraport
          </Link>

          {/* Title */}
          <h1 className="verify-title">Verify your identity</h1>

          {/* Verification Options */}
          <form className="verify-form" onSubmit={handleSubmit}>
            <div className="verify-options">
              <label className={`verify-option ${verifyMethod === 'email' ? 'selected' : ''}`}>
                <input
                  type="radio"
                  name="verifyMethod"
                  value="email"
                  checked={verifyMethod === 'email'}
                  onChange={(e) => setVerifyMethod(e.target.value)}
                />
                <span className="radio-custom"></span>
                <span className="option-text">Email me: bobs****@***.***</span>
              </label>

              <label className={`verify-option ${verifyMethod === 'text' ? 'selected' : ''}`}>
                <input
                  type="radio"
                  name="verifyMethod"
                  value="text"
                  checked={verifyMethod === 'text'}
                  onChange={(e) => setVerifyMethod(e.target.value)}
                />
                <span className="radio-custom"></span>
                <span className="option-text">Text me: ***-****1234</span>
              </label>
            </div>

            <button type="submit" className="btn-send-code">
              Send the code
            </button>
          </form>

          {/* Links */}
          <Link to="/login" className="back-to-login-link">
            Go back to login
          </Link>

          <a href="#" className="support-link">
            Need help? Chat Support
          </a>
        </div>
      </div>

      {/* Bottom Info Section */}
      <div className="verify-info-section">
        <div className="info-card">
          <h3>Join the community</h3>
          <p>Our <a href="https://www.facebook.com/groups/ontraportusers" target="_blank" rel="noopener noreferrer">Facebook User Community</a> is a great place to ask questions and stay updated.</p>
        </div>
        <div className="info-card">
          <h3>Get two months free</h3>
          <p>Switch to a yearly plan and save. After you log in, go to Account &gt; Change plan.</p>
        </div>
        <div className="info-card">
          <h3>Explore our free video courses</h3>
          <p>Learn how to use Ontraport to build your business with <a href="https://ontraportuniversity.com" target="_blank" rel="noopener noreferrer">Ontraport University</a>.</p>
        </div>
      </div>
    </div>
  );
}

export default VerifyIdentityPage;
